





















































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import Draggable from 'vuedraggable'
import CommonModal from '@/components/common/CommonModal.vue'
import CommonButton from '@/components/common/CommonButton.vue'
import CommonAddButton from '@/components/common/CommonAddButton.vue'

export interface CoverPhotoFile {
  id: number
  file: File | string | null
}

export interface CoverPhotoWide {
  type: 1
  files: CoverPhotoFile[]
}

export interface CoverPhotoSquare {
  type: 3
  files: CoverPhotoFile[]
}

export type CoverPhoto = CoverPhotoWide | CoverPhotoSquare

interface CoverPhotoParsedFile {
  id: number
  name: string | null
}

@Component({
  components: {
    Draggable,
    CommonModal,
    CommonButton,
    CommonAddButton,
  },
})
export default class BuilderCoverPhotoModal extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: CoverPhoto

  get files(): CoverPhotoParsedFile[] {
    return this.value.files.map(({ id, file }) => ({
      id,
      name: file instanceof File ? file.name : file,
    }))
  }

  onTypeChange(type: number): void {
    this.$emit('input', {
      type,
      files: Array.from(new Array<CoverPhoto>(type)).map((_, i) =>
        i < type && this.value.files[i]
          ? this.value.files[i]
          : { id: -Number(Date.now().toString()) - i, file: null }
      ),
    })
  }

  onRemove(item: CoverPhotoParsedFile): void {
    this.$emit('input', {
      ...this.value,
      files: this.value.files.map((v) => (v.id === item.id ? { ...v, file: null } : v)),
    })
  }

  onFileOrderChange(files: (File | string)[]): void {
    this.$emit('input', {
      ...this.value,
      files,
    })
  }

  onFileChange(files: File[], item: CoverPhotoFile): void {
    this.$emit('input', {
      ...this.value,
      files: this.value.files.map((v) => (v.id === item.id ? { ...v, file: files[0] } : v)),
    })
  }
}
